import { render, staticRenderFns } from "./ProcessItem.vue?vue&type=template&id=6c0a1f3b&scoped=true"
import script from "./ProcessItem.vue?vue&type=script&lang=js"
export * from "./ProcessItem.vue?vue&type=script&lang=js"
import style0 from "./ProcessItem.vue?vue&type=style&index=0&id=6c0a1f3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a1f3b",
  null
  
)

export default component.exports